// extracted by mini-css-extract-plugin
export var button = "_e7-4";
export var hasDarkBackground = "_e7-7";
export var hasLightBackground = "_e7-6";
export var iconWrapper = "_e7-0";
export var large = "_e7-2";
export var medium = "_e7-1";
export var small = "_e7-5";
export var xsmall = "_e7-3";